import React from "react";
import styled from "styled-components";
import Alert, { AlertDiv } from "../components/Alert";

export const ALERT_INFO = { $info: true };
export const ALERT_DANGER = { $danger: true };
export const ALERT_SUCCESS = { $success: true };

export const UnnamedComponent = (props) => {
  const { content, children, ...restOfProps } = props;

  return (
    <Parent>
      {children}
      <Alert $absolute {...restOfProps}>
        {content}
      </Alert>
    </Parent>
  );
};
export default UnnamedComponent;

const Parent = styled.div`
  position: relative;

  & > ${AlertDiv} {
    display: none;

    &:hover, &:focus, &:focus-within {
      display: block;
    }
  }

  &:hover, &:focus, &:focus-within {
    & > ${AlertDiv} {
      display: block;
    }
  }
`;
